import type { User } from 'firebase/auth';
import md5 from 'md5';

type UserWithKuduIdentity = Pick<User, 'providerData' | 'uid'>;

export function getKuduUserId(
  user: UserWithKuduIdentity | null | undefined,
): string | null {
  const providerUid = user?.providerData[0]?.uid?.trim();

  if (providerUid) {
    return providerUid;
  }

  const fallbackUid = user?.uid?.trim();
  return fallbackUid ? fallbackUid : null;
}

export function createLegacyKuduToken(
  user: UserWithKuduIdentity | null | undefined,
): string | null {
  const providerUid = getKuduUserId(user);

  if (!providerUid) {
    return null;
  }

  return md5(providerUid);
}
